import api from './api';

export const getMembershipSummary = () =>
  api.get('/members/me/membership').then(r => r.data);

// reasonChoice (optional, 2026-09-29): price | no_time | not_using | life_change | other
export const cancelAtRenewal = (reason, reasonChoice) =>
  api.post('/members/me/membership/cancel-at-renewal', { reason, reasonChoice: reasonChoice || undefined }).then(r => r.data);

export const cancelNow = (reason, reasonChoice) =>
  api.post('/members/me/membership/cancel-now', { reason, reasonChoice: reasonChoice || undefined }).then(r => r.data);

export const renewNow = () =>
  api.post('/members/me/membership/renew-now').then(r => r.data);

// Pause + yearly auto-renew (2026-10-07). months: 3 | 6; reason: travelling | health | family
export const pauseMembership = (months, reason) =>
  api.post('/members/me/membership/pause', { months, reason }).then(r => r.data);

export const endPause = () =>
  api.post('/members/me/membership/end-pause').then(r => r.data);

export const setAutoRenew = (on) =>
  api.post('/members/me/membership/auto-renew', { on }).then(r => r.data);

// Payment details (2026-11-03). interval: 'year' | 'month' (Founding Members).
export const chooseFounderPlan = (interval) =>
  api.post('/members/me/membership/founder-plan', { interval }).then(r => r.data);

// A one-time link to Stripe's secure page to see payments and add/change the card.
export const openCardPage = (cardOnly) =>
  api.post('/members/me/membership/card-page', { cardOnly: !!cardOnly }).then(r => r.data);

export const getMySequenceState = () =>
  api.get('/members/me/sequence-state').then(r => r.data);

export const resetMySequence = (sequenceType) =>
  api.post(`/members/me/sequence-state/${sequenceType}/reset`).then(r => r.data);

export const setMyDailyContentEnabled = (enabled) =>
  api.patch('/members/me/daily-content-enabled', { enabled }).then(r => r.data);

// Server-persisted "What kind of day is this?" — was browser-localStorage-only
// before 2026-09-15, so it wasn't visible across the member's own devices or
// checkable by Team365/Claude at all.
export const getMyDayType = () =>
  api.get('/members/me').then(r => r.data.day_type);

export const setMyDayType = (dayType) =>
  api.patch('/members/me/day-type', { dayType }).then(r => r.data);
